import { IDatasetTypeMetadata } from 'app/extensibility/metadatas/resource-type/dataset-type-metadata';

import { ShopifyObjectDataset } from 'app/model/dataset/shopify.dataset';
import { Metamodel } from 'app/model/base/model';
import { ShopifyLinkedService } from 'app/model/linkedservice/shopify.linkedservice';
import { format } from 'app/shared/utils/string.util';
import { GlobalVariables } from 'app/services/globals';
import { ColumnType, defaultSupportedColumnTypes } from 'app/shared/utils/column-type.util';

export const shopifyObjectMetadata: IDatasetTypeMetadata = {
    type: Metamodel.modelFor(ShopifyObjectDataset).name,
    displayName: stringResources.Shopify_DisplayText,
    supportLinkedServiceTypes: [Metamodel.modelFor(ShopifyLinkedService).name],
    showWarningMessage: '{ linkedService && linkedService.version !== "v2" }',
    warningMessage: GlobalVariables.enableShopifyV2 ? format(
             stringResources.Dataset_Legacy_IsNotSupportedWarning_alt3,
         stringResources.VersionLabel.toLocaleLowerCase()) : undefined,
    warningMessageHyperlink: 'https://learn.microsoft.com/azure/data-factory/connector-shopify',
    isSource: true,
    isSink: false,
    datasetKind: 'table',
    icon: {
        className: 'svg-i-100x100-shopify'
    },
    isFirstClass: true,
    supportCreatedAsV2: true,
    notSupportPhysicalType: true,
    supportDataTypes: defaultSupportedColumnTypes.concat(ColumnType.UInt64, ColumnType.Date),
    isTableNameRequired: GlobalVariables.enableQueryShopifyV2 ? false : `{ linkedService && linkedService.version === "v2" }`,
    notSupportCopySourceQuery: GlobalVariables.enableQueryShopifyV2 ? false : `{ linkedService && linkedService.version === "v2" }`,
    queryDisplayName: format(stringResources.ModelName_DisplayTextPreviewTemplate, stringResources.GraphQLQueryLabel),
    queryTooltipLink: 'https://learn.microsoft.com/en-us/azure/data-factory/connector-shopify?tabs=data-factory#shopify-as-source',
    v1SupportSchema: true,
    category: ['ServicesApps']
};
